import BaseComponent from 'scripts/BaseComponent.js';

export default class QuickShopProductCard extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      textarea: '.js-quickShopCardMessage',
      clearBtn: '.js-quickShopCardMessageClear',
    };

    this.dom = {
      $component: component,
      $textarea: this.$get(this.refs.textarea),
      $clearBtn: this.$get(this.refs.clearBtn),
    };

    this.state = {
      clearBtnActiveClass: 'active',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setOnEventWithElement('input', dom.$textarea, this.setClearButton);
    this.setClick(dom.$clearBtn, this.clearMessage);
  }

  setClearButton(textarea) {
    const { dom, state } = this;

    if (textarea.value) {
      dom.$clearBtn.classList.add(state.clearBtnActiveClass);
    } else {
      dom.$clearBtn.classList.remove(state.clearBtnActiveClass);
    }
  }

  clearMessage() {
    const { dom } = this;
    dom.$textarea.value = '';
  }
}
